import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Orders from './pages/Orders';
import UnusedLabels from './pages/UnusedLabels';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import MarkupSettings from './pages/MarkupSettings';
import ActivityLog from './pages/ActivityLog';
import Reconciliation from './pages/Reconciliation';
import RefundsReady from './pages/RefundsReady';
import PendingRefunds from './pages/PendingRefunds';
import ZelleFunding from './pages/ZelleFunding';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router future={{ v7_relativeSplatPath: true }}>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/customers" element={<Customers />} />
                        <Route path="/activity" element={<ActivityLog />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/unused-labels" element={<UnusedLabels />} />
                        <Route path="/reconciliation" element={<Reconciliation />} />
                        <Route path="/refunds" element={<RefundsReady />} />
                        <Route path="/refunds/pending" element={<PendingRefunds />} />
                        {process.env.REACT_APP_ENABLE_ZELLE_FUNDING === 'true' && (
                          <Route path="/zelle-funding" element={<ZelleFunding />} />
                        )}
                        <Route path="/analytics" element={<Analytics />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/settings/markup" element={<MarkupSettings />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
